import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ACSApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { ProjectDtoRelV2 } from '../../../commonTypes/project.types';
import { useTranslation } from '../../useTranslation';
import { setCachedProjects, setProjectsLoading, selectCachedProjects } from '../../../store/slices/projects.slice';

const useHttpGetAllProjectsWithAssignees = () => {
    const { t } = useTranslation('newNotifications');
    const acsApi: ACSApi = useContainer(ACSApi);
    const dispatch = useDispatch();
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const cachedProjects = useSelector(selectCachedProjects);

    const [isReady, setIsReady] = useState(false);
    const [projects, setProjects] = useState<ProjectDtoRelV2[]>(cachedProjects);

    useEffect(() => {
        if (cachedProjects.length > 0) {
            setProjects(cachedProjects);
            setIsReady(true);
            return;
        }

        dispatch(setProjectsLoading(true));

        const { exec, abort } = acsApi.getAllProjectsWithAssignees({
            onSuccess: res => {
                dispatch(setCachedProjects(res.body));
                setProjects(res.body);
            },
            onError: _ => toastHandler.push('error', t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, []);

    useEffect(() => {
        if (cachedProjects.length > 0) {
            setProjects(cachedProjects);
        }
    }, [cachedProjects]);

    return { isReady, projects, setProjects };
};

export default useHttpGetAllProjectsWithAssignees;
